const papers = {
  sci: [
    {
      id: 1,
      title: "Determination of quality levels of fish oils recovered from trout waste using machine learning and odor sensors",
      authors: "Yavuzer, E., Uslu, D.Y., Köse, M., Yetişen, M., Alaşalvar, H., Şimşek, H.İ.",
      journal: "Journal of Food Measurement and Characterization",
      year: 2025,
      doi: "10.1007/s11694-025-03564-4",
      url: "https://unis.ahievran.edu.tr/yayin-detay/2_D3GvDp0_36/determination-of-quality-levels-of-fish-oils-recovered-from-trout-waste-using-machine-learning-and-odor-sensors"
    },
    {
      id: 2,
      title: "Determination of Quality Changes of Hard-Boiled Chicken Eggs Due to Slow and Fast Cooling by Electronic Nose and Machine Learning",
      authors: "Denli, M., Yavuzer, E., Tangüler, H., Köse, M., Yalçın, M.K., Macit, H., Yetişen, M.",
      journal: "Turkish Journal of Agriculture - Food Science and Technology (TURJAF)",
      year: 2025,
      volume: "13",
      issue: "4",
      pages: "934-940",
      doi: "10.24925/turjaf.v13i4.934-940.7352",
      url: "https://unis.ahievran.edu.tr/yayin-detay/2_D38oDZ0_92/determination-of-quality-changes-of-hard-boiled-chicken-eggs-due-to-slow-and-fast-cooling-by-electronic-nose-and-machine-learning"
    },
    {
      id: 3,
      title: "RF Fingerprinting Using Transient-Based Identification Signals at Sampling Rates Close to the Nyquist Limit",
      authors: "Taşcıoğlu, S., Kalaycıoğlu, A., Köse, M., Soysal, G.",
      journal: "ELECTRONICS",
      year: 2025,
      volume: "14",
      issue: "1",
      pages: "13",
      doi: "10.3390/electronics14010004",
      url: "https://unis.ahievran.edu.tr/yayin-detay/2_CpWvCZ0_89/rf-fingerprinting-using-transient-based-identification-signals-at-sampling-rates-close-to-the-nyquist-limit"
    },
    {
      id: 4,
      title: "Non-contact identification of essential oils with IR sensors and analysis of components with an electronic nose",
      authors: "Yavuzer, E., Yalçın, M.K., Uslu, H., Köse, M.",
      journal: "Acta Alimentaria",
      year: 2024,
      volume: "53",
      issue: "3",
      pages: "474-486",
      doi: "10.1556/066.2024.00117",
      url: "https://unis.ahievran.edu.tr/yayin-detay/2_D34vCp4_20/non-contact-identification-of-essential-oils-with-irsensors-and-analysis-of-components-with-anelectronic-nose"
    },
    {
      id: 5,
      title: "Determining the quality level of ready to-eat stuffed mussels with Arduino-based electronic nose",
      authors: "Yavuzer, E., Köse, M., Uslu, H.",
      journal: "Journal of Food Measurement and Characterization",
      year: 2024,
      volume: "18",
      issue: "7",
      pages: "5629-5637",
      doi: "10.1007/s11694-024-02593-9",
      url: "https://unis.ahievran.edu.tr/yayin-detay/2_Cp8qE30_16/determining-the-quality-level-of-ready-to-eat-stuffed-mussels-with-arduino-based-electronic-nose"
    },
    {
      id: 6,
      title: "Sequential Transient Detection for RF Fingerprinting",
      authors: "Taşcıoğlu, S., Köse, M., Soysal, G.",
      journal: "ELECTRONICS",
      year: 2022,
      volume: "11",
      issue: "20",
      pages: "1-19",
      doi: "10.3390/electronics11203333",
      url: "https://unis.ahievran.edu.tr/yayin-detay/2_CJKvCpS_96/sequential-transient-detection-for-rf-fingerprinting"
    },
    {
      id: 7,
      title: "Prediction of fish quality level with machine learning",
      authors: "Yavuzer, E., Köse, M.",
      journal: "International Journal of Food Science & Technology",
      year: 2022,
      doi: "10.1111/ijfs.15853",
      url: "https://unis.ahievran.edu.tr/yayin-detay/2_CJKvCpO_92/prediction-of-fish-quality-level-with-machine-learning"
    },
    {
      id: 8,
      title: "RF Fingerprinting of IoT Devices Based on Transient Energy Spectrum",
      authors: "Köse, M., Taşcıoğlu, S., Telatar, Z.",
      journal: "IEEE ACCESS",
      year: 2019,
      volume: "7",
      pages: "12-18726",
      doi: "10.1109/ACCESS.2019.2896696",
      url: "https://unis.ahievran.edu.tr/yayin-detay/2_CJKvCpK_88/rf-fingerprinting-of-iot-devices-based-on-transient-energy-spectrum"
    },
    {
      id: 9,
      title: "Signal-to-noise ratio estimation of noisy transient signals",
      authors: "Köse, M., Taşcıoğlu, S., Telatar, Z.",
      journal: "Communications Faculty of Sciences University of Ankara Series A2-A3: Physical Sciences and Engineering",
      year: 2015,
      volume: "57",
      issue: "2",
      pages: "11-19",
      url: "https://unis.ahievran.edu.tr/yayin-detay/2_CJKvD30_1/signal-to-noise-ratio-estimation-of-noisy-transient-signals"
    },
    {
      id: 10,
      title: "Wireless device identification using descriptive statistics",
      authors: "Köse, M., Taşcıoğlu, S., Telatar, Z.",
      journal: "Communications Faculty of Sciences University of Ankara Series A2-A3: Physical Sciences and Engineering",
      year: 2015,
      volume: "57",
      issue: "2",
      pages: "1-10",
      url: "https://unis.ahievran.edu.tr/yayin-detay/2_CJKvD34_5/wireless-device-identification-using-descriptive-statistics"
    },
    {
      id: 11,
      title: "Bayesian change point analysis using the phase distribution of complex signals",
      authors: "Köse, M., Taşcıoğlu, S., Telatar, Z.",
      journal: "Communications Faculty of Sciences University of Ankara Series A2-A3: Physical Sciences and Engineering",
      year: 2011,
      volume: "53",
      issue: "1",
      pages: "15-23",
      url: "https://unis.ahievran.edu.tr/yayin-detay/2_CJKvD38_9/bayesian-change-point-analysis-using-the-phase-distribution-of-complex-signals"
    }
  ],
  national: [
    {
      id: 12,
      title: "Değişim noktası kestirimi için CUSUM algoritmasının başarım değerlendirmesi",
      authors: "Köse, M., Taşcıoğlu, S., Telatar, Z.",
      journal: "DÜMF Mühendislik Dergisi",
      year: 2018,
      volume: "9",
      issue: "1",
      pages: "99-108",
      url: "https://unis.ahievran.edu.tr/yayin-detay/2_CJKvCpa_10/degisim-noktasi-kestirimi-icin-cusum-algoritmasininbasarim-degerlendirmesi"
    },
    {
      id: 13,
      title: "Polinom uydurma yöntemi kullanarak RF parmak izi çıkarımı",
      authors: "Taşcıoğlu, S., Köse, M., Telatar, Z.",
      journal: "DÜMF Mühendislik Dergisi",
      year: 2018,
      volume: "9",
      issue: "1",
      pages: "89-97",
      url: "https://unis.ahievran.edu.tr/yayin-detay/2_CJKvCpW_0/polinom-uydurma-yontemi-kullanarak-rf-parmak-izicikarimi"
    }
  ],
  conferences: [
    {
      id: 14,
      title: "Artificial Intelligence Image Processing with YOLO Algorithm for a Quadruped Robot",
      authors: "Köse, M., Mert, B., Kaygusuz, M., Ilgın, H.A.",
      conference: "33rd Signal Processing and Communications Applications Conference (SIU)",
      year: 2025,
      location: "İstanbul, Türkiye",
      month: "Ağustos",
      doi: "10.1109/SIU66497.2025.11111751",
      url: "https://unis.ahievran.edu.tr/yayin-detay/2_D3GpD3O_0/artificial-intelligence-image-processing-with-yolo-algorithm-for-a-quadruped-robot"
    },
    {
      id: 15,
      title: "Real-Time Turkish Video Text Detection and Recognition",
      authors: "Uykun, D., Ilgın, H.A., Köse, M.",
      conference: "9th International Symposium on Innovative Approaches in Smart Technologies (ISAS)",
      year: 2025,
      location: "Gaziantep, Türkiye",
      month: "Ağustos",
      doi: "10.1109/ISAS66241.2025.11101765",
      url: "https://unis.ahievran.edu.tr/yayin-detay/2_D3GpD3K_96/real-time-turkish-video-text-detection-and-recognition"
    },
    {
      id: 16,
      title: "Arduino mikrokontrolör tabanlı çalışan sensörler ve makine öğrenimi ile hamsi kalitesinin hızlı belirleneceği tazelik belirleme kutusu geliştirilmesi",
      authors: "Yavuzer, E., Yetişen, M., Yalçın, M.K., Uslu, D.Y., Köse, M.",
      conference: "VI. INTERNATIONAL TURKIC WORLD CONGRESS ON SCIENCE AND ENGINEERING",
      year: 2024,
      location: "Bakü, Azerbaycan",
      month: "Aralık",
      pages: "51-59",
      url: "https://unis.ahievran.edu.tr/yayin-detay/2_D30nCpC_23/arduino-mikrokontrolor-tabanli-calisan-sensorler-ve-makine-ogrenimi-ile-hamsi-kalitesinin-hizli-belirlenecegi-tazelik-belirleme-kutusu-gelistirilmesi"
    },
    {
      id: 17,
      title: "Classification application with small scale flower dataset",
      authors: "Köse, M., İçel, A.",
      conference: "5th International Conference on Innovative Academic Studies ICIAS 2024",
      year: 2024,
      location: "Konya, Türkiye",
      month: "Kasım",
      pages: "133",
      url: "https://unis.ahievran.edu.tr/yayin-detay/2_CpOvE3S_79/classification-application-with-small-scale-flower-dataset"
    },
    {
      id: 18,
      title: "Leaf classification with pre-trained neural networks",
      authors: "Köse, M., Mamur, R.",
      conference: "6th International Conference on Applied Engineering and Natural Sciences ICAENS 2024",
      year: 2024,
      location: "Konya, Türkiye",
      month: "Eylül",
      pages: "158",
      url: "https://unis.ahievran.edu.tr/yayin-detay/2_CpOvEJO_98/leaf-classification-with-pre-trained-neural-networks"
    },
    {
      id: 19,
      title: "Balık Türlerinin Evrişimli Sinir Ağları İle Sınıflandırılması",
      authors: "Demir, S., Köse, M., Yavuzer, E.",
      conference: "4TH INTERNATIONAL CONFERENCE ON ENGINEERING AND APPLIED NATURAL SCIENCES",
      year: 2023,
      month: "Kasım",
      url: "https://unis.ahievran.edu.tr/yayin-detay/2_CJKvD3G_24/balik-turlerinin-evrisimli-sinir-aglari-ile-siniflandirilmasi"
    },
    {
      id: 20,
      title: "Use Of Convolutionary Neural Network As Feature Extractor In Image Classification",
      authors: "Köse, M.",
      conference: "8. INTERNATIONAL SCIENCES AND INNOVATION CONGRESS",
      year: 2023,
      month: "Kasım",
      url: "https://unis.ahievran.edu.tr/yayin-detay/2_CJKvD3O_32/use-of-convolutionary-neural-network-as-feature-extractor-in-image-classification"
    },
    {
      id: 21,
      title: "Using A Pre-Trained Convolutional Neural Network In Chicken Meat Classification",
      authors: "Hussein, M.A.H., Köse, M., Yavuzer, E., Şanlıalp, İ.",
      conference: "8. INTERNATIONAL SCIENCES AND INNOVATION CONGRESS",
      year: 2023,
      month: "Kasım",
      url: "https://unis.ahievran.edu.tr/yayin-detay/2_CJKvD3K_28/using-a-pre-trained-convolutional-neural-network-in-chicken-meat-classification"
    },
    {
      id: 22,
      title: "Simple security app using real-time facial recognition",
      authors: "Alhammadi, A., Köse, M.",
      conference: "4th International Eurasian Conference on Science, Engineering and Technology (EurasianSciEnTech 2022)",
      year: 2023,
      month: "Ocak",
      pages: "1",
      url: "https://unis.ahievran.edu.tr/yayin-detay/2_CJKvD3C_20/simple-security-app-using-real-time-facial-recognition"
    },
    {
      id: 23,
      title: "Makine öğrenmesi ile balık tazelik seviyesinin tahmini",
      authors: "Doğan, Ö., Yavuzer, E., Köse, M., Tekle, Ş.",
      conference: "5th International Eurasian Conference on Biological and Chemical Sciences (EurasianBioChem 2022)",
      year: 2022,
      month: "Aralık",
      url: "https://unis.ahievran.edu.tr/yayin-detay/2_CJKvD3S_36/makine-ogrenmesi-ile-balik-tazelik-seviyesinin-tahmini"
    },
    {
      id: 24,
      title: "BENZETİM VERİLERİ ÜZERİNDE DAĞITILMIŞ HİZMET REDDİ SALDIRILARININ TESPİTİ İÇİN BİR YAKLAŞIM",
      authors: "Sezen, Ö., Köse, M.",
      conference: "2.ULUSLARARASI MÜHENDİSLİK VE MİMARLIK KONGRESİ",
      year: 2021,
      location: "İstanbul, Türkiye",
      month: "Haziran",
      url: "https://unis.ahievran.edu.tr/yayin-detay/2_CJKvD3W_40/benzetim-verileri-uzerinde-dagitilmis-hizmet-reddi-saldirilarinin-tespiti-icin-bir-yaklasim"
    },
    {
      id: 25,
      title: "Performance Analysis of Transmitter Identification Based on I/Q Imbalance Estimation",
      authors: "Alpergün, Ö., Taşcıoğlu, S., Köse, M.",
      conference: "11th International Conference on Electronics, Computers and Artificial Intelligence (ECAI 2019)",
      year: 2019,
      location: "Piteşti, Romanya",
      month: "Haziran",
      url: "https://unis.ahievran.edu.tr/yayin-detay/2_CJKvD3a_50/performance-analysis-of-transmitter-identification-based-on-iq-imbalance-estimation"
    },
    {
      id: 26,
      title: "Effect of sampling rate on transient based RF fingerprinting",
      authors: "Taşcıoğlu, S., Köse, M., Telatar, Z.",
      conference: "2017 10th International Conference on Electrical and Electronics Engineering (ELECO)",
      year: 2017,
      location: "Bursa, Türkiye",
      month: "Eylül",
      pages: "1156-1160",
      url: "https://unis.ahievran.edu.tr/yayin-detay/2_CparD3C_76/effect-of-sampling-rate-on-transient-based-rf-fingerprinting"
    },
    {
      id: 27,
      title: "Effect of Sampling Rate on Transient Based RF Fingerprinting",
      authors: "Taşcıoğlu, S., Köse, M., Telatar, Z.",
      conference: "10th International Conference on Electrical and Electronics Engineering, ELECO 2017",
      year: 2017,
      startDate: "30-10-2017",
      endDate: "02-11-2017",
      pages: "1156-1160",
      language: "İngilizce",
      conferenceType: "Uluslararası",
      status: "Web of Science Kapsamındaki Kongre/Sempozyum",
      url: "https://unis.ahievran.edu.tr/yayin-detay/2_CJKvDJ0_24/effect-of-sampling-rate-on-transient-based-rf-fingerprinting"
    },
    {
      id: 28,
      title: "The effect of transient detection errors on RF fingerprint classification performance",
      authors: "Köse, M., Taşcıoğlu, S., Telatar, Z.",
      conference: "14th Int. Conf. on Circuits, Syst., Electron., Control Signal Process",
      year: 2015,
      location: "Konya, Türkiye",
      month: "Mayıs",
      pages: "89-93",
      url: "https://unis.ahievran.edu.tr/yayin-detay/2_CJKvDJG_47/the-effect-of-transient-detection-errors-on-rf-fingerprint-classification-performance"
    },
    {
      id: 29,
      title: "Kablosuz yerel alan ağları işaret fazlarının istatistiksel analizi",
      authors: "Köse, M., Taşcıoğlu, S., Telatar, Z.",
      conference: "7. İstatistik Kongresi. (ISTKON7)",
      year: 2011,
      location: "Antalya, Türkiye",
      month: "Nisan",
      pages: "344-345",
      url: "https://unis.ahievran.edu.tr/yayin-detay/2_CJKvDJC_43/kablosuz-yerel-alan-aglari-isaret-fazlarinin-istatistiksel-analizi"
    },
    {
      id: 30,
      title: "An approach on identification of 802.11b devices by RF signature in wireless local area networks",
      authors: "Köse, M., Telatar, Z.",
      conference: "18. Sinyal işleme ve uygulamaları kurultayı",
      year: 2010,
      location: "Diyarbakır, Türkiye",
      month: "Nisan",
      pages: "800-803",
      url: "https://unis.ahievran.edu.tr/yayin-detay/2_CJKvDJ4_28/an-approach-on-identification-of-80211b-devices-by-rf-signature-in-wireless-local-area-networks"
    },
    {
      id: 31,
      title: "Görüntü onarmada oluşan çerçeve hatalarının iyileştirilmesi",
      authors: "Köse, M., Telatar, Z.",
      conference: "9. Sinyal İşleme ve Uygulamaları Kurultayı",
      year: 2001,
      location: "Gazi Magosa KKTC, Türkiye",
      month: "Nisan",
      pages: "360-365",
      url: "https://unis.ahievran.edu.tr/yayin-detay/2_CJKvDJ8_32/goruntu-onarmada-olusan-cerceve-hatalarinin-iyilestirilmesi"
    }
  ]
};

export default papers;

